import { useEffect, useMemo, useState } from 'react';
import { useTopBarLeftContent } from './context/TopBarLeftContentContext';
import { useMobileFilter } from './context/MobileFilterContext';
import CollapsibleFilterGroup from './CollapsibleFilterGroup';
import MobileFilterDrawer from './ui/MobileFilterDrawer';

const PLATFORM_OPTIONS = [
  { value: 'todas', label: 'Todas' },
  { value: 'GOOGLE', label: 'Google Ads' },
  { value: 'META', label: 'Meta Ads' },
];

const STATUS_OPTIONS = [
  { value: 'todos', label: 'Todos' },
  { value: 'activos', label: 'Activos' },
  { value: 'proximos', label: 'Próximos' },
  { value: 'finalizados', label: 'Finalizados' },
];

const METRICA_OPTIONS = [
  { value: 'todas', label: 'Todas' },
  { value: 'Inversión', label: 'Inversión' },
  { value: 'ROAS', label: 'ROAS' },
  { value: 'CPA', label: 'CPA' },
  { value: 'Conversiones', label: 'Conversiones' },
];

export default function ObjetivosFilterBar({
  filtroPlataforma,
  setFiltroPlataforma,
  filtroEstado,
  setFiltroEstado,
  filtroMetrica,
  setFiltroMetrica,
}) {
  const { registerContent, clearContent } = useTopBarLeftContent();
  const { isMobileFilterOpen, closeMobileFilter } = useMobileFilter();
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

  // Track window resize to update responsive layout
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const filtersContent = useMemo(() => {
    const isSmallScreen = windowWidth < 1024; // Mobile (<768px) + Tablet (768-1023px) both use drawer

    if (isSmallScreen) {
      // Compact version for mobile and small screens: Icon-only filter button
      return null; // Filter icon now in MobileTopNavBar
    }

    // Desktop version: Keep original layout
    return (
    <div
      className="backdrop-blur-xl bg-gradient-to-br from-slate-800/90 via-slate-900/90 to-indigo-900/90 border border-white/20 rounded-xl p-3 flex-shrink-0"
      data-testid="objetivos-sticky-filter"
    >
      <div className="flex flex-wrap items-center gap-3">
        <CollapsibleFilterGroup
          label="Plataforma"
          value={filtroPlataforma}
          options={PLATFORM_OPTIONS}
          onChange={setFiltroPlataforma}
        />
        <CollapsibleFilterGroup
          label="Estado"
          value={filtroEstado}
          options={STATUS_OPTIONS}
          onChange={setFiltroEstado}
        />
        <CollapsibleFilterGroup
          label="Métrica"
          value={filtroMetrica}
          options={METRICA_OPTIONS}
          onChange={setFiltroMetrica}
        />
      </div>
    </div>
    );
  }, [
    windowWidth,
    filtroPlataforma,
    filtroEstado,
    filtroMetrica,
    setFiltroPlataforma,
    setFiltroEstado,
    setFiltroMetrica,
  ]);

  useEffect(() => {
    registerContent(filtersContent);
    return () => clearContent();
  }, [filtersContent, registerContent, clearContent]);

  const isSmallScreen = windowWidth < 1024; // Mobile (<768px) + Tablet (768-1023px) both use drawer

  return (
    <>
      {/* Mobile filter drawer - shows on mobile and small screens */}
      {isSmallScreen && (
        <MobileFilterDrawer
          isOpen={isMobileFilterOpen}
          onClose={closeMobileFilter}
          filters={[
            {
              key: 'platform',
              label: 'Plataforma',
              options: PLATFORM_OPTIONS
            },
            {
              key: 'status',
              label: 'Estado',
              options: STATUS_OPTIONS
            },
            {
              key: 'metric',
              label: 'Métrica',
              options: METRICA_OPTIONS
            }
          ]}
          selectedFilters={{
            platform: filtroPlataforma,
            status: filtroEstado,
            metric: filtroMetrica
          }}
          onFilterChange={(key, value) => {
            if (key === 'platform') setFiltroPlataforma(value);
            else if (key === 'status') setFiltroEstado(value);
            else if (key === 'metric') setFiltroMetrica(value);
          }}
          darkMode={true}
        />
      )}
    </>
  );
}
